import { render, staticRenderFns } from "./RadioGroupAppointment.vue?vue&type=template&id=49a0dbcf&"
import script from "./RadioGroupAppointment.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RadioGroupAppointment.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a0dbcf')) {
      api.createRecord('49a0dbcf', component.options)
    } else {
      api.reload('49a0dbcf', component.options)
    }
    module.hot.accept("./RadioGroupAppointment.vue?vue&type=template&id=49a0dbcf&", function () {
      api.rerender('49a0dbcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/VisitLocationFilters/components/RadioGroupAppointment/RadioGroupAppointment.vue"
export default component.exports